import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=2806a536&scoped=true&"
import script from "./charge.vue?vue&type=script&lang=ts&"
export * from "./charge.vue?vue&type=script&lang=ts&"
import style0 from "./charge.vue?vue&type=style&index=0&id=2806a536&scoped=true&lang=stylus&"
import style1 from "./charge.vue?vue&type=style&index=1&id=2806a536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806a536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VFlex,VLayout})
